//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { ref, onMounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { useUtils } from '@core/libs/i18n'
import themeConfig from '@themeConfig'
import {
  mdiClose,
  mdiAccountGroup,
  mdiEyeOutline,
  mdiEyeOffOutline,
  mdiCheckCircleOutline,
  mdiHelpCircleOutline,
} from '@mdi/js'
import { required, emailValidator } from '@core/utils/validation'
import usePhone from '@core/utils/usePhone'
import parsePhoneNumber from 'libphonenumber-js'
import useCountry from '@core/utils/useCountry'
import useLogData from '@core/utils/useLogData'
import useCryptoJs from '@core/utils/useCryptoJs'
import { useRouter } from '@core/utils'
import { deleteUserAccount } from '@api'
import store from '@/store'

export default {
  setup() {
    const { t } = useUtils()
    const { phoneCodeOptions, initPhoneConfig } = usePhone()
    const { getCountryCode } = useCountry()
    const { logData, currentLogData, updateLogData } = useLogData()
    const { userData } = useCryptoJs()
    const { router } = useRouter()

    const circle = ref({
      circle_id: null,
      circle_logo: null,
      circle_name: null,
    })
    const circleId = ref(null)
    const refCode = ref(null)
    const hasException = ref(false)
    const invalidInvitation = ref(false)
    const isOpen = ref(false)
    const isOpenConfirm = ref(false)

    const form = ref(null)
    const phoneInput = ref(null)
    const initCode = ref('')
    const isPhoneVisible = ref(false)

    const code = ref(null)
    const phoneCode = ref(null)
    const fullPhone = ref(null)

    const onDelete = async () => {
      isOpenConfirm.value = false
      if (userData.value) {
        await deleteUserAccount()
        isOpen.value = true
        store.dispatch('auth/logoutAction')
      }
    }

    const verifySubmit = async () => {
      if (userData.value) {
        isOpenConfirm.value = true
      } else {
        logData.value.joinGame = 'NO'
        logData.value.matchCode = null
        logData.value.redirect = 'deletion-request'
        logData.value.field = 'all'
        logData.value.date = 'all'
        logData.value.time = 'all'
        await updateLogData(logData.value)
        router.push({ name: 'auth-login-phone-email' })
      }
    }

    const onClearCode = () => {
      isPhoneVisible.value = false
    }

    const validatePhone = e => {
      if (!/^([0-9])*$/.test(e)) {
        isPhoneVisible.value = false

        return 'Invalid number'
      }

      if (phoneCode.value && e) {
        const phoneNumberJS = parsePhoneNumber(e, phoneCode.value)
        if (phoneNumberJS) {
          if (phoneNumberJS.isValid()) {
            fullPhone.value = phoneNumberJS.number

            return true
          }
          fullPhone.value = null
        }
      } else if (!code.value.includes('+')) {
        onClearCode()
      }

      return 'Invalid number'
    }

    const onInputCode = e => {
      if (!isPhoneVisible.value && e && e !== '' && e.length) {
        if (e.length > 1) {
          if (/^\+?([0-9])+$/.test(e)) {
            code.value = code.value.replace('+', '')
            phoneCode.value = initCode.value
            isPhoneVisible.value = true
          }
        }
      }
    }

    onMounted(async () => {
      Object.assign(logData.value, currentLogData.value)
      const countryCode = getCountryCode()
      if (countryCode) {
        const codeFinded = phoneCodeOptions.value.find(e => e.value === countryCode)
        if (codeFinded) initCode.value = countryCode
        else initCode.value = 'US'
      }

      isPhoneVisible.value = false

      // setTimeout(() => {
      //   if (userData.value) phoneInput.value.focus()
      // }, 500)
    })

    return {
      circle,
      circleId,
      refCode,
      hasException,
      invalidInvitation,
      isOpen,
      isOpenConfirm,

      userData,
      form,
      phoneInput,
      initCode,
      isPhoneVisible,
      code,
      phoneCode,
      phoneCodeOptions,
      logData,

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      appLogoTitle: themeConfig.app.logoTitle,

      verifySubmit,
      validatePhone,
      initPhoneConfig,
      onInputCode,
      onClearCode,

      onDelete,
      avatarText,

      t,

      validators: {
        required,
        emailValidator,
      },

      icons: {
        mdiClose,
        mdiAccountGroup,
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiCheckCircleOutline,
        mdiHelpCircleOutline,
      },
    }
  },
}
